import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useConfigSitio } from '../hooks/useConfigSitio';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
L.Marker.prototype.options.icon = L.icon({ iconUrl: icon, shadowUrl: iconShadow, iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34] });

function FitBounds({ coords }) {
  const map = useMap();
  useEffect(() => {
    if (coords.length === 1) {
      map.setView([coords[0].lat, coords[0].lng], 15);
    } else if (coords.length > 1) {
      const bounds = L.latLngBounds(coords.map(c => [c.lat, c.lng]));
      map.fitBounds(bounds, { padding: [50, 50] });
    }
  }, []); // eslint-disable-line
  return null;
}

function localidadDe(c) {
  if (c.localidad) return c.localidad;
  if (!c.domicilio) return '';
  const partes = c.domicilio.split(',');
  return partes[partes.length - 1].trim();
}

export default function QuienesSomos() {
  const config = useConfigSitio();
  const [corredores, setCorredores] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroLoc, setFiltroLoc] = useState('Todas');

  useEffect(() => {
    async function cargar() {
      try {
        // vendedores es público; usuarios requiere auth. Mejor esfuerzo con usuarios:
        // si el visitante es anónimo y falla, mostramos todos los vendedores igual.
        const vendedoresSnap = await getDocs(collection(db, 'vendedores'));
        let noCorredorIds = new Set();
        try {
          const usuariosSnap = await getDocs(collection(db, 'usuarios'));
          noCorredorIds = new Set(
            usuariosSnap.docs.filter(d => d.data().rol !== 'corredor').map(d => d.id)
          );
        } catch (e) { /* anónimo: sin acceso a usuarios, no filtramos por rol */ }
        const lista = vendedoresSnap.docs
          .map(d => ({ ...d.data(), id: d.id }))
          .filter(c => c.nombre && !noCorredorIds.has(c.id) && !c.dadaDeBaja && !c.ocultarEnPublico)
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setCorredores(lista);
      } catch (e) {
        console.error(e);
      }
      setCargando(false);
    }
    cargar();
  }, []);

  const localidades = [
    'Todas',
    ...Array.from(new Set(corredores.map(c => localidadDe(c)).filter(Boolean))).sort(),
  ];

  const filtrados = filtroLoc === 'Todas'
    ? corredores
    : corredores.filter(c => localidadDe(c) === filtroLoc);

  return (
    <div style={{ padding: '40px 20px', maxWidth: '1100px', margin: '0 auto', fontFamily: 'sans-serif' }}>

      {/* ── CABECERA ── */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h1 style={{ fontSize: '36px', color: '#1a1a1a', marginBottom: '10px' }}>
          {config.quienesTitulo}
        </h1>
        <p style={{ fontSize: '18px', color: '#666', maxWidth: '700px', margin: '0 auto', lineHeight: '1.6' }}>
          {config.quienesTexto}
        </p>
      </div>

      {/* ── PILARES ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '60px' }}>
        <div style={cardStyle}>
          <div style={iconStyle}>🏛️</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#1a1a1a' }}>Respaldo Institucional</h3>
          <p style={{ color: '#555', lineHeight: '1.6', fontSize: '15px' }}>
            Nuestra plataforma cuenta con el apoyo de la <strong>Cámara Inmobiliaria de Formosa (CIF)</strong>. Solo los profesionales asociados a la CIF pueden publicar inmuebles aquí.
          </p>
        </div>
        <div style={cardStyle}>
          <div style={iconStyle}>✅</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#1a1a1a' }}>Propiedades Autorizadas</h3>
          <p style={{ color: '#555', lineHeight: '1.6', fontSize: '15px' }}>
            Olvidate de las publicaciones falsas o dudosas. Cada propiedad en FormoProp cuenta con la autorización legal correspondiente del propietario para ser comercializada.
          </p>
        </div>
        <div style={cardStyle}>
          <div style={iconStyle}>🤝</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#1a1a1a' }}>Trato Seguro</h3>
          <p style={{ color: '#555', lineHeight: '1.6', fontSize: '15px' }}>
            Al hacer clic en "Contactar", te comunicás con el Corredor o Agente Inmobiliario responsable de la propiedad, garantizando un asesoramiento legal y transparente.
          </p>
        </div>
      </div>

      {/* ── MARTILLEROS / CORREDORES MIEMBROS ── */}
      <div style={{ marginBottom: '60px' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <p style={{ margin: '0 0 6px', fontSize: '12px', color: '#007bff', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
            Cámara Inmobiliaria de Formosa
          </p>
          <h2 style={{ margin: '0 0 10px', fontSize: '26px', fontWeight: '900', color: '#1a1a1a' }}>
            🏅 Martilleros y Corredores asociados
          </h2>
          <p style={{ margin: '0 auto', color: '#666', fontSize: '15px', maxWidth: '560px' }}>
            Todos los profesionales habilitados y socios activos de la CIF. Hacé clic en cualquiera para ver su perfil y su cartera de propiedades.
          </p>
        </div>

        {/* Filtro por localidad */}
        {!cargando && localidades.length > 2 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', marginBottom: '28px' }}>
            {localidades.map(loc => (
              <button
                key={loc}
                onClick={() => setFiltroLoc(loc)}
                style={{
                  padding: '7px 18px', borderRadius: '20px', fontSize: '13px', fontWeight: '600',
                  cursor: 'pointer', border: filtroLoc === loc ? 'none' : '1.5px solid #d1d5db',
                  background: filtroLoc === loc ? '#1e3a5f' : 'white',
                  color: filtroLoc === loc ? 'white' : '#374151',
                  transition: 'all 0.15s',
                }}
              >
                {loc === 'Todas' ? '📍 Todas las localidades' : `📍 ${loc}`}
                {loc !== 'Todas' && (
                  <span style={{ marginLeft: '6px', opacity: 0.7, fontWeight: 'normal' }}>
                    ({corredores.filter(c => localidadDe(c) === loc).length})
                  </span>
                )}
              </button>
            ))}
          </div>
        )}

        {/* Grid de miembros */}
        {cargando ? (
          <div style={{ textAlign: 'center', color: '#aaa', padding: '40px' }}>Cargando miembros...</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(290px, 1fr))', gap: '16px' }}>
            {filtrados.map(c => {
              const ciudad = localidadDe(c);
              return (
                <Link
                  key={c.id}
                  to={c.slug ? `/${c.slug}` : `/corredor/${c.id}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div
                    style={{
                      background: 'white', borderRadius: '14px', padding: '18px 20px',
                      boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
                      display: 'flex', alignItems: 'center', gap: '14px',
                      transition: 'box-shadow 0.2s, transform 0.2s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.13)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'none'; }}
                  >
                    {/* Avatar */}
                    {c.fotoPerfilUrl
                      ? <img src={c.fotoPerfilUrl} alt="" style={{ width: '52px', height: '52px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: '2px solid #f0f0f0' }} />
                      : c.logoUrl
                        ? <img src={c.logoUrl} alt="" style={{ width: '52px', height: '52px', objectFit: 'contain', borderRadius: '8px', flexShrink: 0, border: '1px solid #eee' }} />
                        : <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0 }}>🏠</div>
                    }

                    {/* Info */}
                    <div style={{ minWidth: 0 }}>
                      <p style={{ margin: '0 0 3px', fontWeight: '700', fontSize: '14px', color: '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {c.nombre}
                      </p>
                      {ciudad && (
                        <span style={{
                          display: 'inline-block', marginBottom: '5px',
                          padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600',
                          background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe',
                        }}>
                          📍 {ciudad}
                        </span>
                      )}
                      <p style={{ margin: 0, fontSize: '12px', color: '#007bff', fontWeight: '600' }}>
                        Ver perfil →
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>

      {/* ── MAPA DE CORREDORES ── */}
      {(() => {
        const corConCoords = filtrados.filter(c => c.lat && c.lng);
        if (corConCoords.length === 0) return null;
        return (
          <div style={{ marginBottom: '60px' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: '0 0 8px', fontSize: '22px', fontWeight: '800', color: '#1a1a1a' }}>
                📍 Dónde encontrarnos
              </h2>
              <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                Hacé clic en un pin para ver el corredor
              </p>
            </div>
            <div style={{ height: '420px', borderRadius: '14px', overflow: 'hidden', border: '1px solid #e5e7eb', boxShadow: '0 4px 16px rgba(0,0,0,0.07)' }}>
              <MapContainer
                center={[-24.5, -60]}
                zoom={7}
                style={{ height: '100%' }}
                scrollWheelZoom={false}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
                <FitBounds coords={corConCoords} />
                {corConCoords.map(c => (
                  <Marker key={c.id} position={[c.lat, c.lng]}>
                    <Popup>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: '180px' }}>
                        {c.fotoPerfilUrl
                          ? <img src={c.fotoPerfilUrl} alt="" style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                          : c.logoUrl
                            ? <img src={c.logoUrl} alt="" style={{ width: '44px', height: '44px', objectFit: 'contain', borderRadius: '6px', flexShrink: 0 }} />
                            : <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>🏠</div>
                        }
                        <div>
                          <p style={{ margin: '0 0 4px', fontWeight: '700', fontSize: '13px', color: '#1a1a1a' }}>{c.nombre}</p>
                          {localidadDe(c) && <p style={{ margin: '0 0 6px', fontSize: '11px', color: '#666' }}>📍 {localidadDe(c)}</p>}
                          <Link
                            to={c.slug ? `/${c.slug}` : `/corredor/${c.id}`}
                            style={{ fontSize: '12px', color: '#007bff', fontWeight: '600', textDecoration: 'none' }}
                          >
                            Ver perfil →
                          </Link>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            </div>
          </div>
        );
      })()}

      {/* ── CTA ── */}
      <div style={{ background: '#007bff', color: 'white', padding: '40px', borderRadius: '15px', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,123,255,0.2)' }}>
        <h2 style={{ margin: '0 0 15px 0' }}>¿Buscás comprar o alquilar?</h2>
        <p style={{ margin: '0 0 25px 0', fontSize: '16px', opacity: 0.9 }}>
          Explorá nuestro catálogo de propiedades verificadas.
        </p>
        <Link to="/" style={{ background: 'white', color: '#007bff', padding: '12px 30px', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold', fontSize: '16px', display: 'inline-block' }}>
          Ver Catálogo
        </Link>
      </div>

    </div>
  );
}

const cardStyle = { background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', textAlign: 'center' };
const iconStyle = { fontSize: '40px', marginBottom: '15px' };
